module.exports = __webpack_public_path__ + "static/img/service-1.66659960.png";